import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId, IconSize } from "./constants.js";
import { useHover } from "./hooks/useHover.js";
import { getColor } from "./theme/currys/color.js";
import { I as Icon } from "./Icon.js";
import ArrowUpRight from "./components/Icons/ArrowUpRight.js";
import AnchorLinkStyles from "./components/AnchorLink/styles.module.scss";
const AnchorLink = React__default.forwardRef((props, ref) => {
  const { id, href, children, className, target = "_self", htmlMarkup = "a", onClick, testId } = props;
  const external = target === "_blank";
  const { hoverRef, isHovered } = useHover(
    ref
  );
  const anchorClasses = classNames(AnchorLinkStyles.anchorlink, className);
  const commonProps = {
    id,
    ["data-testid"]: testId,
    ["data-analyticsid"]: AnalyticsId.AnchorLink,
    onClick
  };
  const renderContent = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    children,
    external && /* @__PURE__ */ jsx(
      Icon,
      {
        className: AnchorLinkStyles.anchorlink__icon,
        svgIcon: ArrowUpRight,
        color: getColor("blueberry", 600),
        hoverColor: getColor("blueberry", 700),
        size: IconSize.XSmall,
        isHovered
      }
    )
  ] });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    htmlMarkup === "a" && /* @__PURE__ */ jsx(
      "a",
      {
        href,
        target,
        className: anchorClasses,
        rel: external ? "noopener noreferrer" : void 0,
        ref: hoverRef,
        ...commonProps,
        children: renderContent()
      }
    ),
    htmlMarkup === "button" && /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: AnchorLinkStyles["anchorlink-wrapper"],
        ref: hoverRef,
        ...commonProps,
        children: /* @__PURE__ */ jsx("span", { className: anchorClasses, children: renderContent() })
      }
    )
  ] });
});
export {
  AnchorLink as A
};
//# sourceMappingURL=AnchorLink.js.map
